export default "__VITE_ASSET__24a24cd0__"